
const m = window.require("discourse/components/modal/bulk-topic-actions");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
